import React, { useEffect } from "react";

import Navbar from "../home/Header/Navbar";
import Addmition from "../home/Footer/footer";


import { Box } from "@mui/material";
import ChristianCollegeTabDetails from "./ChristianDetail/ChristianCollegeTabDetails";
import ChristianCollegeBanner from "./ChristianDetail/ChristianCollegeBanner";

const ChristianCollegeDetail = () => {
    // const [value, setValue] = React.useState("");
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar />
            <ChristianCollegeBanner />
            <Box sx={{ backgroundColor: "#252525" }}>
                <ChristianCollegeTabDetails />
                <Addmition margintop={"40px"} paddingtop={"40px"} />
            </Box>
        </>
    );
};

export default ChristianCollegeDetail;
